module.exports = __webpack_public_path__ + "static/media/Add.3b19d653.svg";